/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Grid, IconButton } from '@mui/material';
import Datagrid from '../../ui/Datagrid';
import { getWellDetailsColumns } from './table_config';
import { isMobile } from 'react-device-detect';
import MobileFeaturedWellGrid from '../../mobile/hydraulics/featuredWellGrid';
import { ShowChart } from '@mui/icons-material';
import { useState } from 'react';
import RheologyChartModal from '../../rheologyModal';

function FeaturedWellGrid({ data, gridKey, expanded, units }) {
  const [showChart, setShowChart] = useState({
    data: null,
    open: false
  });

  const renderActions = ({
    row,
  }) => {
    return (
      <Grid container justifyContent="center">
        {<IconButton
          variant="solid"
          onClick={() => {
            setShowChart({
              data: [row],
              open: true
            });
          }}
        >
          <ShowChart />
        </IconButton>}
      </Grid>
    );
  };

  if (isMobile) {
    return <MobileFeaturedWellGrid data={data} gridKey={gridKey} expanded={expanded} units={units} />;
  }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
        <Datagrid
          data={data}
          columns={getWellDetailsColumns(gridKey, units, gridKey === 'drillFluids' ? renderActions : null)}
          getRowId={(row) => row?._id || row?.grid_id || gridKey}
          height="auto"
          hideFooter={data.length < 100}
          pageSize={100}
          editMode="cell"
          toolbar={{
            options: {
              columns: false,
              filters: false,
              density: false,
              export: false,
            },
          }}
        />
        {
          showChart.open && <RheologyChartModal
            wellName={''}
            fluidName={''}
            isOpen={showChart.open}
            graphData={showChart?.data}
            onCloseClick={() => {
              setShowChart({
                data: null,
                open: false
              });
            }}
          />
        }
      </Grid>
    </Grid>
  );
}

export default FeaturedWellGrid;
